/// <amd-module name="Search/Shared/Components/HighlightComponent/HighlightComponent" />

import * as React from "react";
import { IHighlightComponentProps } from "./HighlightComponent.Props";
import { FormatComponent } from "VSS/Platform/Components/Format";

/**
 * Given a text and pattern returns a formatted component with "pattern" highlighted
 */
export class HighlightComponent extends React.Component<IHighlightComponentProps> {
    public render(): JSX.Element | null {
        const { pattern, text, className } = this.props;
        let formattedPart: JSX.Element | string = text;

        if (pattern !== "" && text !== "") {
            const componentDivs: JSX.Element[] = [];
            let count = 0;
            let formatString = "";

            const regexMatch = new RegExp(`(${pattern})`, "gi");
            // Replace each occurrence of the search text with incremental placeholders({0}, {1} etc) 
            // to not encounter the same index error in Format component.
            const textItems = text.split(regexMatch);
            const formattedItems: string[] = [];

            textItems.forEach((textItem: string, index: number) => {
                if (textItem.toLocaleLowerCase() === pattern.toLocaleLowerCase()) {
                    formattedItems[index] = `{${count}}`;
                    count++;
                    componentDivs.push((<b>{pattern}</b>));
                } else {
                    formattedItems[index] = textItem;
                }
            });

            formatString = formattedItems.join("");
            formattedPart = <FormatComponent format={formatString}>{componentDivs}</FormatComponent>;
        }

        return (
            <div className={className}>
                {
                    formattedPart
                }
            </div>
        );
    }
}